import { useEffect } from "react";
import { useSelector } from "react-redux";
import { DataGrid } from "../../components"
import { getLocalized } from "../../redux/localization";
import { adminProductFeturesUrl } from "../../services/urls"
import createProductFeaturesForm from "./create";
import AdminProductFeaturesDetail from "./detail";

const ProductFetures = () => {
    const localize = useSelector(getLocalized);
    const columns = [
        {
            dataField: "Code",
            caption: localize.getString("code")
        },
        {
            dataField: "Name",
            caption: localize.getString("name")
        },
        {
            dataField: "ProductCategoryName",
            caption: localize.getString("productCategoryName")
        },
        {
            dataField: "ProductFeatureValueTypeName",
            caption: localize.getString("ProductFeatureValueTypeName")
        }
    ]
    useEffect(()=> {
        console.log(window.location)
    },[])
    return <DataGrid
        title="Ürün Özellikleri"
        url={adminProductFeturesUrl}
        getByIdUrl={adminProductFeturesUrl}
        columns={columns}
        refObject={{}}
        details={{
            width: "30%",
            height: "50%",
            getByIdUrl: adminProductFeturesUrl,
            title: localize.getString("productFeatureDetail"),
            component: AdminProductFeaturesDetail,
        }}
        create={{
            createUrl: adminProductFeturesUrl,
            component: createProductFeaturesForm,
            width: "40%",
            height: "70%",
            title: localize.getString("createProductFeature"),
            validationGroup : "createProductFeature"
        }}
        edit={{
            editUrl: adminProductFeturesUrl,
            component: createProductFeaturesForm,
            width: "40%",
            height: "60%",
            title: localize.getString("editProductFeature")
        }}
        remove={{
            url: adminProductFeturesUrl
        }}
    />
}

export default ProductFetures